import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=630ac7eb&scoped=true&"
import script from "./CampaignsList.vue?vue&type=script&lang=js&"
export * from "./CampaignsList.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsList.vue?vue&type=style&index=0&id=630ac7eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ac7eb",
  null
  
)

export default component.exports